import React, {Component} from 'react';
import {connectedSelector,userSelector} from "../redux/reducers/authReducer";
import connect from "react-redux/es/connect/connect";
import NotConnected from "../components/NotConnected";
import {checkToken} from "../redux/actionCreators/auth";
import AdminMenu from "../components/adminMenu";
import AdminTable from "../components/adminTable";
import {updateCellHistory, updateHistory} from "../redux/actionCreators/history";
import {lastCellStatesSelector} from "../redux/reducers/historyReducer";
import {dk_blue, dk_gray, dk_light_gray, dk_yellow} from "../constants/style";
import {PulseLoader} from "react-spinners";
import MaterialIcon from "material-icons-react";
import History from "../components/History";
import {allBatteriesSelector} from "../redux/reducers/allBatteriesReducer";
import {fetchAllBatteries} from "../redux/actionCreators/allBatteries";
import {openBatteryIdSelector} from "../redux/reducers/openReducer";
import {fetchBatteryById} from "../redux/actionCreators/batteryById";
import {batteryByIdSelector} from "../redux/reducers/batteryByIdReducer";
import {setOpenBattery} from "../redux/actionCreators/open";
import {removeBatteryFromUser} from "../redux/actionCreators/batteryById";
import {addBatteryToUser} from "../redux/actionCreators/userById";
import {fetchUserById} from "../redux/actionCreators/userById";
import strings from "../screenLocalisation/batteryInfo";
import {userByIdSelector} from "../redux/reducers/userByIdReducer";
import Autocomplete from "react-autocomplete";
import {allUsersSelector} from "../redux/reducers/allUsersReducer";
//import BatteryMenu from "../components/BatteryMenu";
import {removeBattery} from "../redux/actionCreators/batteryById";
import{removeUser} from "../redux/actionCreators/userById";
import AdminBattery from "../components/AdminBattery";
import {myBatteriesSelector} from "../redux/reducers/myBatteriesReducer";
import {fetchMyBatteries} from "../redux/actionCreators/myBatteries";

class Home extends Component {
    constructor(props) {
        super(props)
        this.state = {
            menuVisible: true,
            dropDownVisible: false,
            value: '',
            adminActionSelected: ''
        }
    }
    async componentDidMount() {
        await this.props.checkToken()
        if (!this.props.connected || !this.props.user.isSuperAdmin) {
            this.props.history.push('/login')
        }
    }




    render() {
        if (!this.props.connected) return null
        return (
            <div style={styles.container}>

                <img style={styles.logo} src={require('../assets/img/logo_blue.png')}/>

                <AdminMenu history={this.props.history}/>

                {this.props.batteryById ? this.renderBattery() : this.props.userById ? this.renderUser() : <AdminTable/>}
            </div>
        );
    }

    displayAlertBattery() {
        return prompt('Taper "oui" pour supprimer cette batterie ')
    }
    displayAlertUser() {
        return prompt('Taper "oui" pour supprimer cet utilisateur ')
    }

    renderUser() {
        let {userById, cellStates} = this.props
        if (userById == null) {
            return null
        }

        return (
            <div style={styles.batteryInfo}>
                <div>
                    <h1>{strings.labelUserBattery + ' : ' + userById.fullName}</h1>
                </div>
                <div>
                    <div className={'deleteBatteryButton'} onClick={async () => {
                        const alert = this.displayAlertUser()
                        if(alert === "oui"){
                            const remove = await this.props.removeUser(userById.id)
                            this.props.fetchAllBatteries()
                        }

                    }}>Supprimer l'utilisateur</div>
                </div>
                <div  className={'adminBattery'}>
                    <div className={'adminBatteryUsers'}>
                        <h3>{strings.labelBattery + ' :'}</h3>
                    </div>
                    {userById ?
                        userById.battery_id.map((battery, i) => (

                            <div key={battery.id} className={'rowUserBattery'}>
                                <div className={'batteryUserName'} onClick={()=>{this.props.fetchBatteryById(battery.id)}}>{battery.sn}</div>
                                <div className={'deleteDiv'}>
                                    <div className={'deleteButton'} onClick={async()=>(await this.props.removeBatteryFromUser(userById.id,battery.id),this.props.fetchUserById(userById.id))}>{strings.delete}</div>
                                </div>
                            </div>
                        ))
                        :
                        <PulseLoader color={dk_blue} size={10}/>
                    }
                </div>
                <div>Ajouter une  batterie à cette utilisateur</div>
                {console.log(this.props.allBatteries)}
                <Autocomplete
                    items={this.props.allBatteries}
                    inputProps={{
                        id: "search",
                        name: "search",
                        component: "input",
                        className: "fieldInputSearchBar"
                    }}
                    wrapperProps={{
                        className: "wrapperInputSearchBar"
                    }}
                    wrapperStyle={{display: 'flex', position: 'relative'}}
                    menuStyle={{
                        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                        background: 'rgba(255, 255, 255, 0.9)',
                        paddingLeft: "10px",
                        position: "fixed",
                        overflow: 'auto',
                        width: "100%",
                        maxWidth: "800px",
                        minWidth: "250px",
                        left: "0",
                        right: "0",
                        marginLeft: "auto",
                        marginRight: "auto",
                        maxHeight: '500px', // TODO: don't cheat, let it flow to the bottom
                    }}
                    shouldItemRender={(item, value) => item.sn.toLowerCase().indexOf(value.toLowerCase()) > -1}
                    getItemValue={item => item.sn}
                    renderItem={(item, highlighted) =>
                        <div
                            key={item.id}
                            style={{
                                backgroundColor: highlighted ? '#FFCC00' : 'white',
                                fontSize: "18px",
                                paddingTop: "3px",
                                paddingBottom: "3px"
                            }}
                        >
                            {item.sn}
                        </div>
                    }
                    value={this.state.value}
                    onChange={e => this.setState({value: e.target.value})}
                    onSelect={async (value, item) => {
                        this.setState({value})
                        //const add = await this.props.addBatteryToUser(userById.id,item.sn)
                        //this.props.fetchUserById(userById.id)
                    }}
                    autoHighlight={true}
                />
                <input value={strings.validateLabel} className={'addButton'} type="button" onClick={async () => {
                    const add = await this.props.addBatteryToUser(userById.id,this.state.value)
                    this.props.fetchUserById(userById.id)
                }}/>
            </div>

        )
    }


    renderBattery() {
        let {batteryById, cellStates} = this.props
        console.log(batteryById)

        if (batteryById == null) {
            return null
        }

        return (
            <div style={styles.batteryInfo}>
                <div>
                    <h1>{strings.labelTitle + ' : ' + batteryById.name}</h1>
                    <h3>{strings.labelSn + ' : ' + batteryById.sn}</h3>
                </div>
               <div>
                   <div className={'deleteBatteryButton'} onClick={async () => {
                       const alert = this.displayAlertBattery()
                       if(alert === "oui"){
                           const remove = await this.props.removeBattery(batteryById.id)
                           this.props.fetchAllBatteries()
                       }

                   }}>Supprimer la batterie</div>
               </div>

                <div  className={'adminBattery'}>
                    <div className={'adminBatteryUsers'}>
                        <h3>{strings.labelUserBattery + ' :'}</h3>
                    </div>
                    {batteryById ?
                        batteryById.user_id.map((user, i) => (

                            <div key={user.id} className={'rowUserBattery'}>
                                <div className={'batteryUserName'} onClick={()=>this.props.fetchUserById(user.id)}>{user.fullName}</div>
                                <div className={'deleteDiv'}>
                                    <div className={'deleteButton'} onClick={async ()=>{
                                        const remove = await this.props.removeBatteryFromUser(user.id,batteryById.id)
                                            this.props.fetchBatteryById(batteryById.id)}}>
                                        {strings.delete}</div>
                                </div>

                            </div>



                        ))
                        :
                        <PulseLoader color={dk_blue} size={10}/>
                    }
                </div>
                <div>Ajouter un utilisateur à cette batterie</div>
                <Autocomplete
                    items={this.props.allUsers}
                    inputProps={{
                        id: "search",
                        name: "search",
                        component: "input",
                        className: "fieldInputSearchBar"
                    }}
                    wrapperProps={{
                        className: "wrapperInputSearchBar"
                    }}
                    wrapperStyle={{display: 'flex', position: 'relative'}}
                    menuStyle={{
                        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                        background: 'rgba(255, 255, 255, 0.9)',
                        paddingLeft: "10px",
                        position: "fixed",
                        overflow: 'auto',
                        width: "100%",
                        maxWidth: "800px",
                        minWidth: "250px",
                        left: "0",
                        right: "0",
                        marginLeft: "auto",
                        marginRight: "auto",
                        maxHeight: '500px', // TODO: don't cheat, let it flow to the bottom
                    }}
                    shouldItemRender={(item, value) => item.fullName.toLowerCase().indexOf(value.toLowerCase()) > -1}
                    getItemValue={item => item.id}
                    renderItem={(item, highlighted) =>
                        <div
                            key={item.id}
                            style={{
                                backgroundColor: highlighted ? '#FFCC00' : 'white',
                                fontSize: "18px",
                                paddingTop: "3px",
                                paddingBottom: "3px"
                            }}
                        >
                            {item.fullName}
                        </div>
                    }
                    value={this.state.value}
                    onChange={e => this.setState({value: e.target.value})}
                    onSelect={async (value, item) => {
                        const add = await this.props.addBatteryToUser(item.id,batteryById.sn)
                        this.props.fetchBatteryById(batteryById.id)
                    }
                    }
                    autoHighlight={true}
                />
            <AdminBattery batteryId={batteryById.id}/>
            </div>

        )
    }
}

let valueGrid
if (window.innerWidth > 1330) {
    valueGrid = '25% 25% 25% 25%'
} else if (window.innerWidth > 850) {
    valueGrid = '50% 50%'
} else {
    valueGrid = '100%'
}

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'row'
    },
    batteryInfo: {
        flex: 1,
        padding: 10,
        paddingTop: 65,
        width: '100%'
    },
    dataGroup: {
        flex: 1,
        textAlign: 'center'
    },
    scrollContainer: {
        flex: 1,
        marginRight: 10,
        marginLeft: 10,
        marginTop: 10
    },
    dataTitle: {
        flex: 1,
        marginRight: 20,
        margin: 0,
        height: 10,
        paddingBottom: 5,
        fontSize:13
    },
    dataValue: {
        flex: 1,
        margin: 0,
        height: 20,
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center',
        backgroundColor: dk_light_gray,
        paddingBottom: 5,
        paddingTop: 5,
        gridColumnEnd: 'span 2'
    },
    dataLoader: {
        flex: 1,
        height: 17
    },
    infoLists: {
        display: 'grid',
        gridTemplateColumns: valueGrid,
        // gridTemplateRows: window.innerWidth>1000?'25% 25% 25% 25%':'50% 50%',
        marginTop: 20,
        marginBottom: 20,
    },
    overallInfo: {
        flex: 1
    },
    cellsInfo: {
        flex: 1
    },
    alertsInfo: {
        display: `flex`,
        padding: 15
    },
    activesInfo: {
        flex: 1
    },
    seperationBar: {
        height: 20,
        marginTop: 20,
        marginBottom: 20,
        backgroundColor: dk_yellow
    },
    logo: {
        position: 'absolute',
        top: 15,
        right: 15,
        height: 75,
    }
}

const mapStateToProps = state => ({
    connected: connectedSelector(state),
    cellStates: lastCellStatesSelector(state),
    allBatteries: allBatteriesSelector(state),
    openBattery: openBatteryIdSelector(state),
    batteryById: batteryByIdSelector(state),
    userById: userByIdSelector(state),
    allUsers: allUsersSelector(state),
    user: userSelector(state),
    myBatteries: myBatteriesSelector(state),
})

export default connect(mapStateToProps, {fetchMyBatteries,checkToken, updateCellHistory, updateHistory,fetchAllBatteries,fetchBatteryById,setOpenBattery,removeBatteryFromUser,addBatteryToUser,fetchUserById,removeBattery,removeUser})(Home);